/* eslint-disable */
import React, { useState, useEffect, useContext } from "react";
import { CancelTokenSource } from 'axios';
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import QRCodeReact from "qrcode.react";
import { ReactComponent as SuccessImage } from "../../assets/images/success-icon.svg";
import { SendAccessLink, GetEmployeeID, getCustomerStatesList, GetStatsStatus } from "../../api/user";

import { appConfig } from "../../config/app-config";
import {
  makeStyles,
  Grid,
  RACButton,
  Typography,
  Card,
  CardContent,
  RACTextbox,
  RACRadio,
  CircularProgress,
  RACModalCard,
  RACSelect,
} from "@rentacenter/racstrap";
import { StoreDetail } from "../../types/types";
import { userInfo } from "os";

const useClasses = makeStyles((theme: any) => ({
  w100: {
    width: "100%",
  },
  card: {
    borderRadius: "16px!important",
    boxShadow: "0 1px 4px 0 rgba(0,0,0,.074)!important",
    width: "100%",
  },
  my5: {
    marginTop: theme.typography.pxToRem(48),
    marginBottom: theme.typography.pxToRem(48),
  },
  mb5: {
    marginBottom: theme.typography.pxToRem(48),
  },
  pt2: {
    paddingTop: theme.typography.pxToRem(8),
  },
  px2: {
    paddingRight: theme.typography.pxToRem(8),
    paddingLeft: theme.typography.pxToRem(8),
  },
  cardHeight: {
    height: "15rem",
  },
  colMD12: {
    flex: "0 0 auto",
    width: "100%",
    paddingRight: "0.75rem",
    // paddingLeft: '0.75rem',
  },
  floatStart: {
    float: "left",
  },
  floatEnd: {
    float: "right",
  },
  displayNone: {
    display: "none",
  },
  displayBlock: {
    display: "block",
  },
  mb3: {
    marginBottom: "1rem",
  },
  formLabel: {
    marginBottom: "0.2rem !important",
    color: "#111111",
    fontFamily: "OpenSans-semibold",
    fontSize: "14px",
  },
  formCheckInline: {
    display: "inline-block",
    marginRight: "1rem",
  },
  formCheck: {
    minHeight: "1.5rem",
    marginBottom: "0.125rem",
  },
  checkboxLabel: {
    fontSize: "14px",
    display: "inline-block",
    fontFamily: "OpenSans-regular",
  },
  buttonsContent: {
    float: "right",
    marginTop: "2rem",
  },
  mr10: {
    marginRight: "10px",
  },
  alignCenter: {
    textAlign: "center",
  },
  mt10: {
    marginTop: "30px",
  },
  paddingDone: {
    padding: "12px 25px",
  },
  accessColor: {
    color: "#727171",
  },
}));

function SendDigitalForm() {
  const search = useLocation().search;
  const identifierId = new URLSearchParams(search).get("identifier");
  const { t, i18n } = useTranslation("task");
  const classes = useClasses();
  const [AuthKey, setAuthKey] = useState("");

  const [masterLoader, setmasterLoader] = useState(false);

  const StoreSelected = window.sessionStorage.getItem("storeNumber") || "";
  let langugae = window.sessionStorage.getItem("language") ?? "";
  const language = langugae ? Buffer.from(langugae).toString("base64") : "en";
  const identifier = identifierId
    ? Buffer.from(identifierId).toString("base64")
    : "";

  const [QRCodePopup, SendQRCodePopup] = useState<boolean>(false);
  const [PhoneNumber, SendPhoneNumber] = useState<string>("");
  const [unformatPhoneNumber, setUnformatPhoneNumber] = useState<string>("");
  const [Email, setEmail] = useState<string>("");
  const [QRCodeURL, SendQRCodeURL] = useState<string>("");
  const [IsEmailVerified, setIsEmailVerified] = useState<boolean>(false);
  const [IsSuccessPopUpOpen, setIsSuccessPopUpOpen] = useState<boolean>(false);
  const [IsSendDisabled, setIsSendDisabled] = useState<boolean>(true);
  const [IsPhoneNumberVerified, setIsPhoneNumberVerified] =
    useState<boolean>(false);
  const [IsLookingUpOpen, setIsLookingUpOpen] = useState<boolean>(false);
  const [IsPhysicalStore, setIsPhysicalStore] = useState<boolean>(true);
  const [IsStaticQR, setIsStaticQR] = useState<boolean>(false);
  let [digitalOrderForm, setDigitalOrderForm] = useState<string>("");
  let [EnableMXDOF, setEnableMXDOF] = useState<string>("");
  const [enableContextCheckBox, setEnableContextCheckBox] = useState(false);
  const [IsGenerateqrisabled, setGenerateqrDisabled] = useState<boolean>(true);
  const [countryCode, setCountryCode] = useState([]);  
  const [phoneCountryCode,setPhoneCountryCode] =useState<string>("");
  const [configcountrycode, setconfigcountrycode] = useState(0);
  const [loading, setLoading] = useState(true);

  let [userId, setUserId] = useState<string>("");

  useEffect(() => {
    getConfigDetailsFn();
  }, []);
  useEffect(() => {
    const GetEmployeeIDFn = async () => {
      const GetcurrentUser = await GetEmployeeID();
      console.log("GetEmployeeIDFn", GetcurrentUser);
      if (GetcurrentUser?.status === 200) {
        const GetcurrentUserResponse = GetcurrentUser.data;
        const EmployeeId = GetcurrentUserResponse.employeeId;
        var EnCodeUserId =
          EmployeeId !== undefined
            ? new Buffer(EmployeeId).toString("base64")
            : "";
        setUserId(EnCodeUserId);
      }
    };

    GetEmployeeIDFn();
  }, []);

  useEffect(() => {
    fetchCountryCode ();
  }, []);

  const fetchCountryCode = async ()=>{
    const response = await getCustomerStatesList('country_code');
    if(response?.status==200){
      setCountryCode(response?.data)
      setLoading(false);
    }
  } 

  const storeDetails = sessionStorage.getItem('storeDetails') || '';
    const encodeStoreDetails = Buffer.from(storeDetails, 'base64');

    let decodestoreDetails: any;

    try {
        decodestoreDetails = JSON.parse(
            encodeStoreDetails.toString('utf8')
        );
    } catch (error: any) {
        console.log(error.message)
    }
    const countryStore= decodestoreDetails?.country;   
  
  useEffect(() => {
  if (countryStore) {
    const countryAbb = countryStore.toUpperCase();
    const regionCode = countryCode.filter(
      (item) => item.abbreviation === countryAbb
    );
    if (regionCode.length > 0) {
      setPhoneCountryCode(regionCode[0]?.countryCodeValue);
    }
  }
}, [countryCode]);

  const getConfigDetailsFn = async () => {
    setmasterLoader(true);
    const storeNumber = window.sessionStorage.getItem("storeNumber");
    const payload: any = {
      storeNumbers: [window.sessionStorage.getItem("storeNumber")],
      paramKeyNames: ["DigitalOrderForm", "EnableMXDOF","CountryCode"],
    };
    let getConfigDetailsRes;
    if (
      storeNumber &&
      storeNumber != null &&
      storeNumber != "" &&
      storeNumber != "" &&
      storeNumber != "null" &&
      storeNumber != "undefined"
    ) {
      getConfigDetailsRes = await GetStatsStatus(payload);
    }
    setmasterLoader(false);
    digitalOrderForm =
      getConfigDetailsRes?.data?.storeProfileResponse?.configDetails[0]?.configDetails?.filter(
        (el: any) => el.paramKeyName == "DigitalOrderForm"
      )[0].paramValue;
    setDigitalOrderForm(digitalOrderForm);
    EnableMXDOF =
      getConfigDetailsRes?.data?.storeProfileResponse?.configDetails[0]?.configDetails?.filter(
        (el: any) => el.paramKeyName == "EnableMXDOF"
      )[0]?.paramValue;
    setEnableMXDOF(EnableMXDOF);
    setconfigcountrycode(getConfigDetailsRes?.data?.storeProfileResponse?.configDetails[0]?.configDetails?.filter(
        (el: any) => el.paramKeyName == "CountryCode"
      )[0]?.paramValue)
  };
  const setQRUrl = () => {
    setIsStaticQR(false);
    console.log(appConfig.dofUrl);
    var EnAuthStore =
      StoreSelected !== undefined
        ? new Buffer(StoreSelected).toString("base64")
        : "";
    const EnClientId = new Buffer("RACPAD").toString("base64");

    const type = Buffer.from("NC").toString("base64");

    let URL = "";

    if (digitalOrderForm == "1") {
      if (EnableMXDOF == "1") {
        URL = `${
          appConfig.apiUrls.digiorderform
        }?AuthKey=${AuthKey}&userId=${userId}&StoreCode=${EnAuthStore}&clientId=${EnClientId}&type=${type}&language=${language}${
          identifier ? `&identifier=${identifier}` : ""
        }`;
      } else {
        URL = `${appConfig.apiUrls.orderform}?AuthKey=${AuthKey}&userId=${userId}&StoreCode=${EnAuthStore}&clientId=${EnClientId}`;
      }
    } else {
      URL = `${appConfig.dofUrl}?AuthKey=${AuthKey}`;
    }
    // remove whitespace
    URL = URL.replace(" ", "");
    SendQRCodeURL(URL);
  };

  const setStaticQR = () => {
    setIsStaticQR(true);
    console.log(appConfig.dofUrl);
    var EnAuthStore =
      StoreSelected !== undefined
        ? new Buffer(StoreSelected).toString("base64")
        : "";
    const EnClientId = new Buffer("RACPAD").toString("base64");
    const type = Buffer.from("NC").toString("base64");

    let URL = "";

    if (digitalOrderForm == "1") {
      if (EnableMXDOF == "1") {
        URL = `${
          appConfig.apiUrls.digiorderform
        }?userId=${userId}&StoreCode=${EnAuthStore}&clientId=${EnClientId}&type=${type}&language=${language}${
          identifier ? `&identifier=${identifier}` : ""
        }`;
      } else {
        URL = `${appConfig.apiUrls.orderform}?userId=${userId}&StoreCode=${EnAuthStore}&clientId=${EnClientId}`;
      }
    } else {
      URL = `${appConfig.dofUrl}?StoreCode=${EnAuthStore}&userId=${userId}`;
    }
    // remove whitespace
    URL = URL.replace(" ", "");

    SendQRCodeURL(URL);
  };

  const CreateStaticQRCode = () => {
    setStaticQR();
    //SendDigitalFormPopup(false);
    SendQRCodePopup(true);
  };

  const CreateQRCode = async () => {
    setmasterLoader(true);
    let UserInfo = {
      phoneNumber: configcountrycode == 1 && unformatPhoneNumber !==''
    ? phoneCountryCode + unformatPhoneNumber 
    : unformatPhoneNumber,
      emailAddress: Email,
      storeNumber: StoreSelected !== undefined ? StoreSelected.toString() : "",
      countryCode: configcountrycode == 1 && phoneCountryCode && unformatPhoneNumber ? phoneCountryCode + unformatPhoneNumber : unformatPhoneNumber
    };
  console.log("UserInfo",UserInfo);
    const Requestbody = {
      phoneNumber:
       (UserInfo.phoneNumber !== "" &&
        UserInfo.phoneNumber !== undefined &&
        UserInfo.phoneNumber !== null
          ? UserInfo.phoneNumber
          : ""),
      emailAddress:
        UserInfo.emailAddress !== "" &&
        UserInfo.emailAddress !== undefined &&
        UserInfo.emailAddress !== null
          ? UserInfo.emailAddress
          : "",
      storeNumber: UserInfo.storeNumber,
      newDOF: digitalOrderForm == "1" ? true : false,
      storeCode:
        StoreSelected !== undefined
          ? new Buffer(StoreSelected).toString("base64")
          : "",
      userid: userId,
      encodeClientId: new Buffer("RACPAD").toString("base64"),
      type: EnableMXDOF == "1" ? "NC" : undefined,
      identifier: identifier ? identifier : undefined,
      language: language,
      EnableMXDOF: EnableMXDOF == "1" ? true : false,
      originCountry: countryStore ? countryStore.toUpperCase() : ""
    };
    //console.log(UserInfo);

    let GetAccessToken: any = await SendAccessLink(Requestbody);
    //console.log(GetAccessToken);
    setmasterLoader(false);
    setIsStaticQR(false);

    setAuthKey(GetAccessToken);
    var EnAuthStore =
      StoreSelected !== undefined
        ? new Buffer(StoreSelected).toString("base64")
        : "";
    const EnClientId = new Buffer("RACPAD").toString("base64");
    const type = Buffer.from("NC").toString("base64");

    let URL = "";

    if (digitalOrderForm == "1") {
      if (EnableMXDOF == "1") {
        URL = `${
          appConfig.apiUrls.digiorderform
        }?AuthKey=${GetAccessToken}&userId=${userId}&StoreCode=${EnAuthStore}&clientId=${EnClientId}&type=${type}&language=${language}${
          identifier ? `&identifier=${identifier}` : ""
        }`;
      } else {
        URL = `${appConfig.apiUrls.orderform}?AuthKey=${GetAccessToken}&userId=${userId}&StoreCode=${EnAuthStore}&clientId=${EnClientId}`;
      }
    } else {
      URL = `${appConfig.dofUrl}?AuthKey=${GetAccessToken}`;
    }

    // Optional: remove whitespace
    URL = URL.replace(" ", "");

    SendQRCodeURL(URL);

    if (IsPhysicalStore) {
      SendQRCodePopup(true);
    } else {
      setIsSuccessPopUpOpen(true);
    }
  };
  const HideDigitalPopup = () => {
    SendPhoneNumber("");
    setUnformatPhoneNumber("");
    setEmail("");
    SendQRCodePopup(false);
    setIsSendDisabled(true);
    setIsPhysicalStore(true);
  };
  const HideSuccessPopUp = () => {
    SendPhoneNumber("");
    setUnformatPhoneNumber("");
    setEmail("");
    setIsSendDisabled(true);
    setIsSuccessPopUpOpen(false);
    SendQRCodePopup(false);
    setIsPhysicalStore(true);
    //SendDigitalFormPopup(false);
  };

  const formatByNumeric = (input: string): string => {
    try {
      let onlyNumeric: string = input;
      if (input?.length) {
        return onlyNumeric.replace(/\D/g, "");
      }
      return onlyNumeric;
    } catch (error: any) {
      console.log("Error in formatByNumeric: ", error?.message);
      return input;
    }
  };

  //  Function for formating the Phone number
  const formatPhone = (input: string): string => {
    try {
      let phoneNumber: string = input;
      if (input && input.length > 0) {
        const cleaned = formatByNumeric(input);
        // const PhoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
        // phoneNumber = cleaned.replace(PhoneRegex, '($1) $2-$3');
        // const PhoneRegex = /^(?:\+?([0-9]{2,3})[-. ]?)?\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
        phoneNumber = cleaned.replace(
          /^(?:\+?([0-9]{2,3})[-. ]?)?\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
          "+$1 ($2) $3-$4"
        );
        const match = cleaned.match(
          /^(?:\+?([0-9]{1,3})[-. ]?)?\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/
        );

        if (match) {
          const [, cc, area, prefix, line] = match;
          const allowedCodes = ["1", "52", "91"];

          if (!cc || allowedCodes.includes(cc)) {
            phoneNumber = `${
              cc ? "+" + cc + " " : ""
            }(${area}) ${prefix}-${line}`;
          } else {
            phoneNumber = cleaned; // Return as-is if not allowed
          }
        } else {
          phoneNumber = cleaned; // fallback if not matched
        }
      }
      return phoneNumber;
    } catch (error: any) {
      console.log("Error in formatPhone: ", error?.message);
      return input;
    }
  };

  const OpenAccessLink = () => {
    window.open(QRCodeURL, "_blank");
  };

  const EmailValueVerify = (event: any) => {
    setQRUrl();
    const phoneNumber = PhoneNumber.replace(/[^\d]/g, "");

    // phoneNumberLength is used to know when to apply our formatting for the phone number
    const phoneNumberLength = phoneNumber.length;
    var EmailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    if (event.target.value.length <= 50) {
      if (
        EmailRegex.test(event.target.value) &&
        event.target.value.trim() !== ""
      ) {
        setEmail(event.target.value);
        setIsEmailVerified(true);
        if (EnableMXDOF === "1") {
          if (
            PhoneNumber !== "" &&
            phoneNumberLength >= 10 &&
            enableContextCheckBox
          ) {
            setIsSendDisabled(false);
          } else if (PhoneNumber === "" && enableContextCheckBox) {
            setIsSendDisabled(false);
          } else {
            setIsSendDisabled(true);
          }
        } else {
          if (PhoneNumber !== "" && phoneNumberLength >= 10) {
            setIsSendDisabled(false);
          } else if (PhoneNumber === "") {
            setIsSendDisabled(false);
          } else {
            setIsSendDisabled(true);
          }
        }
      } else {
        setEmail(event.target.value);
        setIsEmailVerified(false);
        if (
          event.target.value === "" &&
          PhoneNumber !== "" &&
          phoneNumberLength >= 10
        ) {
          setIsSendDisabled(false);
        } else {
          setIsSendDisabled(true);
        }
      }
    }
  };

  const handleInput = (e: any) => {
    SendPhoneNumber(e.target.value);
    const cleaned = ("" + e.target.value).replace(/\D/g, "");
    setUnformatPhoneNumber(cleaned);
    setQRUrl();
    if (EnableMXDOF === "1") {
      if (cleaned.length >= 10 && enableContextCheckBox) {
        setIsSendDisabled(false);
      } else {
        setIsSendDisabled(true);
      }
    } else {
      // Non-MX Store: Only check phone length (checkbox not required)
      if (cleaned.length >= 10) {
        setIsSendDisabled(false);
      } else {
        setIsSendDisabled(true);
      }
    }
  };
  const handleCheckboxChange = (isChecked: boolean) => {
    setEnableContextCheckBox(isChecked);
    const cleanedPhone = PhoneNumber.replace(/\D/g, "");
    const isPhoneValid = cleanedPhone.length >= 10;
    const EmailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    const isEmailValid = EmailRegex.test(Email) && Email.trim() !== "";
    const isCheckboxRequired = EnableMXDOF === "1";
    const shouldEnableSend =
      (isPhoneValid || isEmailValid) && (!isCheckboxRequired || isChecked);

    setIsSendDisabled(!shouldEnableSend);
    setGenerateqrDisabled(!isChecked);
  };
  const OpenSucessPopUp = () => {
    SendQRCodePopup(false);
    if (IsStaticQR) {
      setIsSuccessPopUpOpen(false);
    } else {
      setIsSuccessPopUpOpen(true);
    }
  };

  const SetPhysicalStore = () => {
    if (IsPhysicalStore) {
      setIsPhysicalStore(false);
    } else {
      setIsPhysicalStore(true);
    }
  };

  const openModalContent = () => {
    return (
      <Grid>
        <Grid className={classes.alignCenter}>
          {/* <img src={QRCodeURL} id="QRCode" alt="QR" /> */}
          <QRCodeReact value={QRCodeURL} />,
        </Grid>
        <Grid className={`${classes.alignCenter} ${classes.mt10}`}>
          <RACButton
            variant="outlined"
            color="primary"
            className={`${classes.mr10} ${classes.accessColor}`}
            onClick={OpenAccessLink}
          >
            {t("Access Link")}
          </RACButton>
          <RACButton
            variant="contained"
            color="primary"
            className={classes.paddingDone}
            onClick={OpenSucessPopUp}
          >
            {t("Done")}
          </RACButton>
        </Grid>
      </Grid>
    );
  };
  const openModalSuccessContent = () => {
    return (
      <Grid>
        <Grid className={classes.alignCenter}>
          <SuccessImage />
        </Grid>
        <Grid className={`${classes.alignCenter} ${classes.mt10}`}>
          <Typography>
            {EnableMXDOF != "1"
              ? t("Digital Order Form sent successfully.")
              : t("DOF link has been sent successfully.")}
          </Typography>
        </Grid>
        <Grid className={`${classes.alignCenter} ${classes.mt10}`}>
          <RACButton
            variant="contained"
            color="primary"
            onClick={HideSuccessPopUp}
          >
            {t("OK")}
          </RACButton>
        </Grid>
      </Grid>
    );
  };

  return (
    <>
      {masterLoader === true ? (
        <Grid
          style={{
            position: "fixed",
            background: "#f7f5f5",
            width: "100%",
            height: "100%",
            top: 0,
            left: 0,
            opacity: 0.6,
            zIndex: 1050,
            textAlign: "center",
            margin: "0px 0px",
          }}
        >
          <Grid
            style={{
              display: "block",
              position: "fixed",
              zIndex: 9999999,
              top: "40%",
              right: "50%",
            }}
          >
            <CircularProgress />
          </Grid>
        </Grid>
      ) : null}
      <Grid item lg={7}>
        <Card
          className={`${classes.w100}  ${classes.card}  ${classes.cardHeight}`}
        >
          <CardContent>
            <Grid className={`${classes.w100} ${classes.floatStart}`}>
              <Grid className={`${classes.colMD12} ${classes.floatStart}`}>
                <Typography className={`${classes.formLabel} ${classes.w100}`}>
                  {t("Is customer physically in store?")}
                </Typography>
                <Grid
                  className={`${classes.formCheck} ${classes.formCheckInline}`}
                >
                  {/* <input className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" defaultValue="option1" defaultChecked /> */}
                  <RACRadio
                    name="inlineRadioOptions"
                    id="inlineRadio1"
                    defaultValue="option1"
                    value=""
                    size={"small"}
                    onClick={SetPhysicalStore}
                    checked={IsPhysicalStore}
                  />
                  <Typography className={classes.checkboxLabel}>
                    {t("Yes")}
                  </Typography>
                </Grid>
                <Grid
                  className={`${classes.formCheck} ${classes.formCheckInline}`}
                >
                  {/* <input className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" defaultValue="option2" /> */}
                  <RACRadio
                    name="inlineRadioOptions"
                    id="inlineRadio2"
                    defaultValue="option2"
                    value=""
                    size={"small"}
                    onClick={SetPhysicalStore}
                    checked={!IsPhysicalStore}
                  />
                  <Typography className={classes.checkboxLabel}>
                    {t("No")}
                  </Typography>
                </Grid>
                {EnableMXDOF === "1" ? (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <input
                      style={{ height: 16, width: 16 }}
                      type="checkbox"
                      id="flexCheckDefault-7"
                      checked={enableContextCheckBox}
                      onChange={(e) => {
                        handleCheckboxChange(e.target.checked);
                      }}
                    />
                    <label
                      htmlFor="flexCheckDefault-7"
                      style={{
                        marginLeft: 10,
                        fontFamily: "arial",
                        fontSize: "13px",
                        color: "#4A5174",
                      }}
                    >
                      {t(
                        "The client verbally gives me their authorization to send the following link and states that they are aware of our Privacy Notice."
                      )}
                    </label>
                  </div>
                ) : null}
              </Grid>
              <Grid container spacing={3}>
                <Grid item md={6} lg={6}>
                   <Typography className={classes.formLabel}>
                    {EnableMXDOF === "1" ? t("WhatsApp"): t("Phone Number")}
                  </Typography>
                <div style={{width:'100%',
                  display:'flex'}}>
                 {configcountrycode == 1 && (<div style={{width:'15%', 
                   marginTop: 'auto'}}>
                {configcountrycode==1?(<RACSelect
                 defaultValue={phoneCountryCode} 
                 isDisabled={loading}
            onChange={(e) => setPhoneCountryCode(e.target.value)}
            options={countryCode.map((item) => ({
              label: `+${item.countryCodeValue}`,
              value: item.countryCodeValue
            }))}/>):(<div></div>)}
              </div>)}
              <div style={{ width: configcountrycode == 1 ? '85%' : '100%'}}>
                  {/* <Typography className={classes.formLabel}>
                    {t("Phone Number")}
                  </Typography> */}
                  {/* <input type="text" value='' className="form-control" id="PhoneNumber" /> */}
                  <RACTextbox
                    value={formatPhone(PhoneNumber)}
                    OnChange={handleInput}
                    maxlength={(configcountrycode)?10:18}
                  ></RACTextbox>
                  </div>
                  </div>
                </Grid>
                <Grid item md={6} lg={6}>
                  <Typography className={classes.formLabel}>
                    {t("Email")}
                  </Typography>
                  {/* <input type="email" value='' className="form-control" id="Email" /> */}
                  <RACTextbox
                    OnChange={EmailValueVerify}
                    value={Email}
                  ></RACTextbox>
                </Grid>
              </Grid>
            </Grid>
            <Grid className={classes.buttonsContent}>
              {StoreSelected === undefined ? (
                <>
                  <RACButton
                    variant="contained"
                    color="primary"
                    onClick={CreateStaticQRCode}
                    className={classes.mr10}
                  >
                    {t("Generate Store QR")}
                  </RACButton>
                  <RACButton
                    variant="contained"
                    color="primary"
                    disabled={true}
                  >
                    {t("Send")}
                  </RACButton>
                </>
              ) : (
                <>
                  <RACButton
                    variant="contained"
                    color="primary"
                    onClick={CreateStaticQRCode}
                    className={classes.mr10}
                    disabled={EnableMXDOF === "1" ? IsGenerateqrisabled : false}
                  >
                    {t("Generate Store QR")}
                  </RACButton>
                  <RACButton
                    variant="contained"
                    color="primary"
                    onClick={CreateQRCode}
                    disabled={IsSendDisabled}
                  >
                    {t("Send")}
                  </RACButton>
                </>
              )}
            </Grid>
          </CardContent>
        </Card>

        <RACModalCard
          borderRadius="15px"
          closeIcon={true}
          isOpen={QRCodePopup}
          maxWidth={"xs"}
          title={t("Customer can now scan the QR code")}
          onClose={HideDigitalPopup}
          children={openModalContent()}
        ></RACModalCard>
        <RACModalCard
          borderRadius="15px"
          closeIcon={true}
          isOpen={IsSuccessPopUpOpen}
          maxWidth={"xs"}
          title={""}
          onClose={HideSuccessPopUp}
          children={openModalSuccessContent()}
        ></RACModalCard>
      </Grid>
    </>
  );
}

export default SendDigitalForm;
